<!-- src/ChapterNavBar.vue -->
<!-- Previous chapter / back to chapter list / next chapter, with a dropdown of every chapter -->

<template>
  <nav class="chapter-nav dark-gray-box-1 d-flex align-items-start justify-content-between p-2">
    <router-link
      v-if="previousChapter"
      :to="chapterLink(previousChapter)"
      class="chapter-nav-side textwhite textmainhover text-decoration-none subTitleFont"
    >
      <i class="bi bi-chevron-left"></i> Previous
    </router-link>
    <span v-else class="chapter-nav-side textlightgray subTitleFont disabled"><i class="bi bi-chevron-left"></i> Previous</span>

    <div class="d-flex flex-column align-items-center">
      <router-link to="/chapters" class="textwhite textmainhover text-decoration-none fs-4" title="Back to chapter list" aria-label="Back to chapter list">
        <i class="bi bi-arrow-up"></i>
      </router-link>
      <select
        class="form-select form-select-sm chapter-select mt-1"
        data-bs-theme="dark"
        aria-label="Jump to chapter"
        :value="currentChapter"
        @change="goToChapter($event.target.value)"
      >
        <option v-for="chapter in chapters" :key="chapter.ChapterNumber" :value="chapter.ChapterNumber">
          Chapter {{ chapter.ChapterNumber }}<template v-if="chapter.Name">: {{ chapter.Name }}</template>
        </option>
      </select>
    </div>

    <router-link
      v-if="nextChapter"
      :to="chapterLink(nextChapter)"
      class="chapter-nav-side text-end textwhite textmainhover text-decoration-none subTitleFont"
    >
      Next <i class="bi bi-chevron-right"></i>
    </router-link>
    <span v-else class="chapter-nav-side text-end textlightgray subTitleFont disabled">Next <i class="bi bi-chevron-right"></i></span>
  </nav>
</template>

<style scoped>
.chapter-nav-side {
  min-width: 90px;
  padding-top: 0.4rem;
}
.chapter-nav-side.disabled {
  opacity: 0.4;
}
/* Grey dropdown; data-bs-theme="dark" gives it Bootstrap's light arrow */
.chapter-select {
  max-width: 220px;
  background-color: var(--darkgray, rgb(42, 42, 42));
  border-color: var(--lightmidgray, #545454);
  color: var(--purewhite, #ffffff);
}
.chapter-select:focus {
  border-color: var(--main-text-color, #ff0000);
  box-shadow: 0 0 0 0.2rem rgba(255, 0, 0, 0.25);
}
.chapter-select option {
  background-color: var(--darkgray, rgb(42, 42, 42));
  color: var(--purewhite, #ffffff);
}
</style>

<script>
export default {
  name: 'ChapterNavBar',
  props: {
    chapters: { type: Array, required: true }, // newest first, as returned by the API
    currentChapter: { type: Number, required: true },
  },
  computed: {
    currentIndex() {
      return this.chapters.findIndex(chapter => chapter.ChapterNumber === this.currentChapter);
    },
    // The list is newest first, so the previous chapter is the next item in the array
    previousChapter() {
      return this.currentIndex >= 0 ? this.chapters[this.currentIndex + 1] : null;
    },
    nextChapter() {
      return this.currentIndex > 0 ? this.chapters[this.currentIndex - 1] : null;
    },
  },
  methods: {
    chapterLink(chapter) {
      return { name: 'ChapterPage', params: { id: chapter.ChapterNumber } };
    },
    goToChapter(chapterNumber) {
      this.$router.push({ name: 'ChapterPage', params: { id: chapterNumber } });
    },
  },
};
</script>
